import { APICallV2Post } from './APICall';

export class RenameAPICall extends APICallV2Post {
    _method = 'file/rename';
}
